import { DynamicSelectFieldErrorPresentation } from "./DynamicSelectField.error.presenter";
import { ReadyStatePresentation } from "./DynamicSelectField.ready.presenter";
import type { DynamicSelectFieldPresentationProps } from "./DynamicSelectField.type";
import { WaitingDependencyPresentation } from "./DynamicSelectField.waiting.presenter";

/**
 * 動的セレクトフィールドのプレゼンテーション層
 */
export const DynamicSelectFieldPresentation = ({
  uiState,
  options,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  readOnly,
  error,
  placeholder,
  testId,
  getSelectedOptionLabel,
  hasValue,
  onClear,
}: DynamicSelectFieldPresentationProps) => {
  // エラー状態の場合
  if (uiState.type === "error") {
    return <DynamicSelectFieldErrorPresentation />;
  }

  // 依存待ち状態の場合
  if (uiState.type === "waiting-dependency") {
    return <WaitingDependencyPresentation testId={testId} />;
  }

  // 通常状態の場合（type: "ready"）
  return (
    <ReadyStatePresentation
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      readOnly={readOnly}
      error={error}
      placeholder={placeholder}
      testId={testId}
      options={options}
      uiState={uiState}
      getSelectedOptionLabel={getSelectedOptionLabel}
      hasValue={hasValue}
      onClear={onClear}
    />
  );
};
